import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import vuetifyEn from 'vuetify/es5/locale/en';
import mixin from '../mixins/index';
import en from '../locales/en';

Vue.use(Vuetify);

const { themeColors } = mixin.data();

export default new Vuetify({
  lang: {
    current: 'en',
    locales: {
      en: Object.assign({}, vuetifyEn, en)
    }
  },
  theme: {
    themes: {
      light: themeColors
    }
  }
});
